import { OPEN_AI } from './LoginSources';
export const LOGIN_HINT_PARAM = 'login_hint';
export const TARGET_FLOW_PARAM = 'target_flow';
export const CHATGPT_SIWC = 'chatgpt_siwc';
export const TARGET_FLOW_TO_LOGIN_TYPE = {
  [CHATGPT_SIWC]: OPEN_AI
};